import { render } from "./AttributeBlock.vue?vue&type=template&id=4041f18d&scoped=true"
import script from "./AttributeBlock.vue?vue&type=script&lang=js"
export * from "./AttributeBlock.vue?vue&type=script&lang=js"

import "./AttributeBlock.vue?vue&type=style&index=0&id=4041f18d&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4041f18d"]])

export default __exports__